import React from "react";

// Define prop types
interface RoundLoaderProps {
  size?: number;
  color?: string;
  borderWidth?: number;
}

const RoundLoader: React.FC<RoundLoaderProps> = ({
  size = 10,
  color = "#f92c2c",
  borderWidth = 4,
}) => {
  return (
    <div className="fixed inset-0 z-50 flex justify-center items-center bg-[#070b28] bg-opacity-30 backdrop-blur-sm">
      <div
        className="animate-spin rounded-full"
        style={{
          width: `${size * 4}px`,
          height: `${size * 4}px`,
          borderWidth: `${borderWidth}px`,
          borderColor: `${color}`,
          borderTopColor: "transparent",
          borderStyle: "solid",
        }}
      />
    </div>
  );
};

export default RoundLoader;
